angular
  .module('directives.billing-workflow.billing-tasks-assigned', [
    'api',
    'kareo.featureSetAreas',
    'kareo.ui.shared.modules.api.user.k-user-service'
  ])
  .component('billingTasksAssigned', {
    controller: TasksAssignedController,
    controllerAs: 'vm',
    template: require('./billing-tasks-assigned.tpl.pug')()
  });

TasksAssignedController.$inject = [
  'activeCustomerProducts',
  'featureSet',
  'featureSetAreas',
  '$q',
  'kUserService',
  'openBillingTasksService'];

function TasksAssignedController(
  activeCustomerProducts,
  featureSet,
  featureSetAreas,
  $q,
  kUserService,
  openBillingTasksService) {
  var vm = this;
  vm.showBillingTasksAssigned = false;
  vm.loaded = false;
  vm.loadError = false;

  openBillingTasksService.getOpenBillingTasksSummary()
    .then((openBillingTasks) => {
      vm.openBillingTasks = openBillingTasks;
      vm.loaded = true;
    });

  $q.all([
    featureSetAreas.load(),
    kUserService.isRcmEmployee(),
    activeCustomerProducts.get(),
    featureSet.load()
  ]).then((responses) => {
    initFeatures(responses[0], responses[1], responses[2], responses[3]);
  });

  function initFeatures(featuresetAreas, isRcmEmployee, customerProduct, darkFeatures) {
    var isKmbCustomer = !!customerProduct.RCM;
    var relaxedPlatform = darkFeatures['dark-feature.billing-tasks-relaxed-platform-perm'];
    // 'billingTaskEnabled' shows the Billing tasks link in the chrome header
    var billingTaskEnabled = (featuresetAreas['feature-set.area.billing-tasks'].show || isRcmEmployee) || (isKmbCustomer && relaxedPlatform);
    var uxEnhancement = darkFeatures['dark-feature.billing-tasks-ux-enhancements'];
    // show the card when billingTaskEnabled and uxEnhancement toggle on
    vm.showBillingTasksAssigned = billingTaskEnabled && uxEnhancement;
  }
}
